import { GET_FLASHSALES, GET_FLASHSALE } from '../actions/flashsale/type';

const initState = { flashsales: [], flashsale: { header: null, items: null } };
export default function (state = initState, action) {
  switch (action.type) {
    case GET_FLASHSALES:
      return { ...state, flashsales: action.payload };
    case GET_FLASHSALE:
      return { ...state, flashsale: action.payload };
    default:
      return state;
  }
}